import { jsx as r } from "react/jsx-runtime";
import { AudioIcon as i } from "./AudioIcon.js";
import { ImageIcon as n } from "./ImageIcon.js";
import { VideoIcon as c } from "./VideoIcon.js";
import { PdfIcon as m } from "./PdfIcon.js";
import { ExcelIcon as e } from "./ExcelIcon.js";
import { DocIcon as a } from "./DocIcon.js";
import { AnyFileIcon as f } from "./AnyFileIcon.js";
function W({ type: t, size: o = 24 }) {
  if (t.startsWith("audio"))
    return /* @__PURE__ */ r(i, { size: o });
  if (t.startsWith("image"))
    return /* @__PURE__ */ r(n, { size: o });
  if (t.startsWith("video"))
    return /* @__PURE__ */ r(c, { size: o });
  switch (t) {
    case "application/pdf":
      return /* @__PURE__ */ r(m, { size: o });
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    case "application/vnd.ms-excel":
      return /* @__PURE__ */ r(e, { size: o });
    case "application/msdoc":
      return /* @__PURE__ */ r(a, { size: o });
    default:
      return /* @__PURE__ */ r(f, { size: o });
  }
}
export {
  W as WebFileIcon
};
//# sourceMappingURL=WebFileIcon.js.map
